import React from 'react';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import UnidEntityDataTable from './components/unid-entity-data-table';
import { useUnidEntitySearchController } from './context/unid-entity-search-controller';
import PageHeader from '../../../components/page-header';

export function UnidEntitySearchComponent() {
    const {
        navigateToCreate
    } = useUnidEntitySearchController();

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Unidades da Entidade"
                    subtitle="Gerencie as unidades e entidades do sistema"
                    breadcrumbs={[
                        { label: 'Unidades da Entidade' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        minHeight: "700px",
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <UnidEntityDataTable props={{}} />
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={navigateToCreate}
                        icon={<SpeedDialIcon />}
                    />
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
